import { useEffect, useState } from 'react'
import isBrowser from '../utils/isBrowser'
declare global {
  interface Window {
    Klarna?: {
      OnsiteMessaging?: {
        refresh: () => void
      }
    }
  }
}
const isScriptLoadedInBody = () => !!document.querySelector('#klarnaOSM')
const useKlarnaModule = (instalmentSalePrice: number) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(isBrowser() && isScriptLoadedInBody())
  useEffect(() => {
    if (isScriptLoaded) return
    const script = document.createElement('script')
    script.setAttribute('data-environment', 'production')
    script.setAttribute('async', 'true')
    script.setAttribute('data-client-id', '0b7506d8-61c1-579e-af8a-318251fac4af')
    script.setAttribute('id', 'klarnaOSM')
    script.src = 'https://osm.klarnaservices.com/lib.js'
    document.body.appendChild(script)
    setIsScriptLoaded(true)
  }, [isScriptLoaded])
  useEffect(() => {
    if (!isScriptLoaded) return
    isBrowser() && window.Klarna?.OnsiteMessaging?.refresh()
  }, [instalmentSalePrice, isScriptLoaded])
  return isScriptLoaded
}
export default useKlarnaModule
